import sectionImage from "../../../assets/homePageV2/footer.png";
import { heroFechamentoContent as c } from "./content";

export function Footer() {
  return (
    <section
      className="home-page-v2__section home-page-v2__section--hero-fim"
      style={{
        backgroundImage: `url(${sectionImage})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover'
      }}
    >
      <div className="home-page-v2__section--hero-fim__subBanner"/>
      <div className="home-page-v2__section-inner home-page-v2__hero-fim-inner">
        <h2 className="home-page-v2__brand home-page-v2__brand--closing">
          {c.title}
        </h2>
        <p>{c.tagline}</p>
      </div>
    </section>
  );
}
